// toast.js
import { toast } from "react-toastify";

const notifySuccess = (message: string) =>
  toast.success(message, {
    autoClose: 10000,
    theme: "colored",
  });
const notifyError = (message: string) =>
  toast.error(message, {
    autoClose: 10000,
    theme: "colored",
  });
const notifyInfo = (message: string) =>
  toast.info(message, {
    autoClose: 10000,
    theme: "colored",
  });
const notifyWarning = (message: string) =>
  toast.warn(message, {
    autoClose: 10000,
    theme: "colored",
  });

export { notifySuccess, notifyError, notifyInfo, notifyWarning };
